import { SVGProps } from 'react'

export const Navigation = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" viewBox="0 0 20 20" {...props}>
    <path fill="currentColor" d="M10 2.083L3.75 17.326l.592.592 5.658-2.5 5.658 2.5.592-.592L10 2.084z"></path>
  </svg>
)
